import { render, staticRenderFns } from "./ConfigAlertDiscord.vue?vue&type=template&id=c252ab76&"
import script from "./ConfigAlertDiscord.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertDiscord.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAlertDiscord.vue?vue&type=style&index=0&id=c252ab76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports